import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { _GlobalConstants } from '../../../services/globalConstants.service';
import {_UsersService} from "../../../services/users.service";

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var defaultSettingsGrid;

@Component({
  selector: 'users-h',
  templateUrl: './users-h.component.html',
  styleUrls: ['./users-h.component.css'],
})

export class UsersHistory implements OnInit, OnDestroy {

  private subscription: any;
  private users: any;

  constructor (private route: ActivatedRoute, private titleService: Title, private constants: _GlobalConstants, private userService: _UsersService) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | User Event Log");

    this.subscription = this.userService.getUsers().subscribe((res) => {
      this.users = res;
      this.ready();
    });
  }

  ready() {
      var users = this.users;

    	// User Session Events.

    	// initialize jqxGrid
    	var sourceUserSession = {
    		datatype : "json",
    		datafields : [{
    			name : 'eventId',
    			type : 'string'
    		}, {
    			name : 'eventTimestamp',
    			type : 'date',
    			format : 'yyyy-MM-dd HH:mm:ss.fff'
    		}, {
    			name : 'eventUserId',
    			type : 'string'
    		}, {
          name: 'eventUserDisplayName',
          type: 'string',
          value: 'eventUserId',
          values: {
            source: users,
            value: 'userId',
            name: 'displayName'
          }
        }, {
    			name : 'eventIpAddress',
    			type : 'string'
    		}, {
    			name : 'eventAction',
    			type : 'string'
    		}, {
    			name : 'eventActionDisplayName',
    			type : 'string',
    			value: 'eventAction',
    			values: {
    				source: this.constants.getTranslatedValues('resources.sessionEvent.action'),
    				value: 'value',
    				name: 'display'
    			}
    		}, {
    		 name : 'byUserId',
    		 type : 'string'
    		}, {
          name: 'byUserDisplayName',
          type: 'string',
          value: 'byUserId',
          values: {
            source: users,
            value: 'userId',
            name: 'displayName'
          }
        }, {
    			name : 'reason',
    			type : 'string'
    		}, {
    			name : 'reasonDisplayName',
    			type : 'string',
    			value: 'reason',
    			values: {
    				source: this.constants.getTranslatedValues('resources.sessionEvent.reason'),
    				value: 'value',
    				name: 'display'
    			}
    		}, {
    			name : 'message',
    			type : 'string'
    		}],
    		id : 'eventId',
    		url : '/ajax/sessions/events',
    		type : 'GET',
    		async : true
    	};
    	var settingsUserSesion = defaultGridViewSettings("#userSessionGrid", sourceUserSession);
    	settingsUserSesion.columns = [{
    		text : 'Timestamp',
    		columntype : 'datetimeinput',
    		datafield : 'eventTimestamp',
    		cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
    		width : '160'
    	}, {
    		text : 'User',
    		columntype : 'textbox',
    		datafield : 'eventUserDisplayName',
    		width : '110'
    	}, {
    		text : 'IP Address',
    		columntype : 'textbox',
    		datafield : 'eventIpAddress',
    		width : '80'
    	}, {
    		text : 'Action',
    		columntype : 'textbox',
    		datafield : 'eventActionDisplayName',
    		width : '100'
    	}, {
    		text : 'By User',
    		columntype : 'textbox',
    		datafield : 'byUserDisplayName',
    		width : '110'
    	}, {
    		text : 'Reason',
    		columntype : 'textbox',
    		datafield : 'reasonDisplayName',
    		width : '150'
    	}, {
    		text : 'Message',
    		columntype : 'textbox',
    		datafield : 'message',
    		width : '300'
    	}];

    	$("#userSessionGrid").jqxGrid(settingsUserSesion);

    }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/users-h/users-h.component.ts